import { FileDocumentArrowRightOutlineIcon } from './FileDocumentArrowRightOutlineIcon';

/**
 * author: Andrej Sharapov
 * id DF8391C4-0B76-4A72-A39E-4DDB40092B8C
 * name file-document-arrow-right-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-arrow-right-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileTextMoveOutlineIcon = FileDocumentArrowRightOutlineIcon;
export default FileTextMoveOutlineIcon